
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.106 2.19c0-.433.118-.856.338-1.216.22-.36.532-.641.897-.807.366-.166.768-.21 1.156-.125.388.085.744.293 1.024.6.28.306.47.696.547 1.121.077.425.038.865-.114 1.266a2.16 2.16 0 01-.736.983c-.33.24-.716.369-1.112.369-.53 0-1.039-.23-1.414-.642a2.301 2.301 0 01-.586-1.549zm2 7.12c-.395 0-.782.128-1.11.369a2.16 2.16 0 00-.737.983c-.152.4-.191.84-.114 1.265.077.425.268.816.547 1.122.28.306.636.515 1.024.6.388.084.79.04 1.156-.125.365-.166.678-.447.897-.807.22-.36.337-.784.337-1.217a2.3 2.3 0 00-.585-1.549 1.916 1.916 0 00-1.415-.641zm0 9.309c-.395 0-.782.128-1.11.37a2.16 2.16 0 00-.737.982c-.152.4-.191.841-.114 1.266.077.425.268.815.547 1.121.28.307.636.515 1.024.6.388.084.79.041 1.156-.125.365-.165.678-.446.897-.806.22-.36.337-.784.337-1.218 0-.58-.21-1.138-.585-1.548a1.916 1.916 0 00-1.415-.642z","fill":"#910000"}})])
          )
        }
      }
    